// Libs
import { IDoesFilterPassParams } from "ag-grid-community";
import { CustomFilterProps, useGridFilter } from "ag-grid-react";
import { Fragment, forwardRef, useCallback, useRef } from "react";

// Local
import {
  TaskStatus,
  getReadableTaskStatus,
  isValidTaskStatusValue,
} from "../../models/task-status";
import BaseInputCheckbox from "../BaseInputCheckbox";
import { useSiteKeyDocStore } from "../../store/site-key-doc";
import BaseButtonSecondary from "../BaseButtonSecondary";

const TaskStatusCustomFilter = forwardRef(
  (
    {
      model,
      onModelChange,
      getValue,
    }: CustomFilterProps<any, any, { value: string[] }>,
    ref,
  ) => {
    const siteKeyDoc = useSiteKeyDocStore((state) => state.siteKeyDoc);

    const refInput = useRef<HTMLInputElement>(null);

    const doesFilterPass = useCallback(
      ({ node }: IDoesFilterPassParams) => {
        const nodeValue = getValue(node);
        if (model && isValidTaskStatusValue(nodeValue)) {
          return model.value.includes(String(nodeValue));
        } else return false;
      },
      [model],
    );

    const afterGuiAttached = useCallback(() => {
      window.setTimeout(() => {
        refInput.current?.focus();
      });
    }, []);

    useGridFilter({
      doesFilterPass,
      afterGuiAttached,
    });

    const onChange = (value: string[] | null) => {
      if (value == null) {
        onModelChange(null);
      } else {
        onModelChange({ value });
      }
    };

    return (
      <Fragment>
        <form className="flex h-full max-h-96 w-fit flex-col gap-2 rounded-md p-3">
          {Object.keys(TaskStatus).map((taskStatus) => {
            return (
              isValidTaskStatusValue(Number(taskStatus)) &&
              siteKeyDoc?.validTaskStatusCodes.includes(Number(taskStatus)) && (
                <BaseInputCheckbox
                  key={taskStatus}
                  label={getReadableTaskStatus(Number(taskStatus))}
                  checked={
                    model != null ? model.value.includes(taskStatus) : false
                  }
                  onChange={(event) => {
                    const value = event.target.checked;
                    if (value === true) {
                      const modelCopy = model === null ? [] : [...model!.value];
                      onChange([...modelCopy, taskStatus]);
                    } else {
                      const modelCopy = [...model!.value];
                      const taskStatusIndex = modelCopy.findIndex(
                        (value) => taskStatus === value,
                      );
                      modelCopy.splice(taskStatusIndex, 1);
                      if (modelCopy.length === 0) {
                        onChange(null);
                      } else {
                        onChange(modelCopy);
                      }
                    }
                  }}
                  ref={refInput}
                  className="form-control"
                />
              )
            );
          })}
          <BaseButtonSecondary
            type="button"
            className="form-control"
            onClick={() => onChange(null)}
          >
            Reset
          </BaseButtonSecondary>
        </form>
      </Fragment>
    );
  },
);

export default TaskStatusCustomFilter;
